﻿const notEmpty = value => typeof value !== 'undefined' && value !== '';

export default function validateInput(rule = notEmpty, ...inputs) {
    let inputIsValid = (input) => {
        if(rule(input.value)) {
            input.parentElement.classList.remove('has-error');
            return true;
        } else {
            input.parentElement.classList.add('has-error');

            const onBlur = e => {
                inputIsValid(input);
                e.target.removeEventListener('blur', onBlur);
            }; 

            input.addEventListener('blur', onBlur);

            return false;
        }
    };

    if(inputs.length == 1) {
        let input = inputs[0];
        return inputIsValid(input);
    }

    let allValid = true;
    for(let input of inputs) {
        if(!inputIsValid(input)) {
            allValid = false;
        }
    }

    return allValid;
}